module.exports = __webpack_public_path__ + "static/media/background_detail.426ddfc2.png";